import React from 'react'
import cx from 'classnames'
import { path } from 'ramda'
import { format } from 'date-fns'
import { components } from 'react-select'
import { Select } from '../../../../../../views/components'
import styles from './PortfolioSelector.module.scss'
import { dateUtils } from '../../../../../../utils'
import PortfolioStatusLabel from '../../../PortfolioStatusLabel'

interface PortfolioSelectorProps {
  name: string
  onChange: (selectedOption: any) => void
  leases: Array<{
    id: string
    label: string
    value: string
    term: Array<string>
    updatedAt: number
  }>
}

const ValueContainer = ({ children, ...props }: any) => {
  return (
    <components.ValueContainer {...props}>
      <div className={styles['value-container']}>
        {children}
        <PortfolioStatusLabel portfolioId={path(['selectProps', 'value', 'id'], props)} />
      </div>
    </components.ValueContainer>
  )
}

const Option = (props: any) => {
  const { data, getStyles, innerProps, isDisabled, isSelected, isFocused } = props
  const classes = cx(styles.option, {
    [styles['option--is-selected']]: isSelected,
    [styles['option--is-focused']]: isFocused,
  })

  const startDate = path(['term', 0], data)
  const endDate = path(['term', 1], data)
  // @ts-expect-error
  const startDateFormatted = startDate && format(new Date(startDate), 'dd MMM yyyy')
  // @ts-expect-error
  const endDateFormatted = endDate && format(new Date(endDate), 'dd MMM yyyy')

  const term =
    startDate && endDate
      ? `${startDateFormatted} -> ${endDateFormatted}`
      : `Edited ${dateUtils.timeAgo(new Date(data.updatedAt))}`

  return !isDisabled ? (
    <div {...innerProps} style={getStyles('option', props)} className={classes}>
      <div>
        <strong>{data.label}</strong>
        <span>{term}</span>
      </div>
      <PortfolioStatusLabel portfolioId={data.id} />
    </div>
  ) : null
}

const PortfolioSelector = ({ name = 'account-selector', onChange, leases, ...props }: PortfolioSelectorProps) => {
  return (
    <section className={styles.root}>
      <Select {...props} name={name} options={leases} components={{ Option, ValueContainer }} onChange={onChange} />
    </section>
  )
}

export default PortfolioSelector
